import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';

export const FormContainer = styled.div`
  background: ${colors.neutralLight40};
  border-radius: 2px;
  padding: ${sizes.large}px;
  width: 328px;
`;
